"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.dbAuth = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/json/stringify"));

const dbAuth = () => {
  const getToken = async () => {
    const response = await fetch(`${global.__REDWOOD__API_PROXY_PATH}/auth?method=getToken`);
    const token = await response.text();
    return token;
  };

  const login = async attributes => {
    const {
      username,
      password
    } = attributes;
    const response = await fetch(`${global.__REDWOOD__API_PROXY_PATH}/auth`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: (0, _stringify.default)({
        username,
        password,
        method: 'login'
      })
    });
    return await response.json();
  };

  const logout = async () => {
    await fetch(`${global.__REDWOOD__API_PROXY_PATH}/auth`, {
      method: 'POST',
      body: (0, _stringify.default)({
        method: 'logout'
      })
    });
    return true;
  };

  const signup = async attributes => {
    const response = await fetch(`${global.__REDWOOD__API_PROXY_PATH}/auth`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: (0, _stringify.default)({ ...attributes,
        method: 'signup'
      })
    });
    return await response.json();
  };

  return {
    type: 'dbAuth',
    client: () => null,
    login,
    logout,
    signup,
    getToken,
    getUserMetadata: getToken
  };
};

exports.dbAuth = dbAuth;